/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automationplatform.chirp.rpc.DelayedActionsService
 */

export const getDelayActionEnrollmentCountsRpc = {
  serviceName: 'com.hubspot.automationplatform.chirp.rpc.DelayedActionsService',
  rpcName: 'getDelayActionEnrollmentCounts',
  auth: 'app',
  fingerprint: 'v3XPROU2pfn6P5kcb1Q6p1N5r1lEUJKI'
};